import { render, staticRenderFns } from "./ExtractionDocumentsDialog.vue?vue&type=template&id=f8a9cf04"
import script from "./ExtractionDocumentsDialog.vue?vue&type=script&lang=js"
export * from "./ExtractionDocumentsDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtractionDocumentsDialog.vue?vue&type=style&index=0&id=f8a9cf04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports